const devopsRoutes = [
  {
    path: 'devops/document',
    name: 'Document',
    component: () => import('@/views/Document'),
    meta: {
      title: '知识库',
      icon: 'document',
      requireApiPermission: ['base.document.view']
    }
  },
  {
    path: 'devops/inventory',
    name: 'Inventory',
    component: () => import('@/layouts/BlankLayout'),
    meta: {
      title: '资产盘点',
      icon: 'container',
      requireApiPermission: ['base.inventory.view']
    },
    children: [
      {
        path: 'host',
        name: 'HostInventory',
        meta: {
          title: '服务器'
        },
        component: () => import('@/views/HostInventory')
      },
      {
        path: 'software',
        name: 'SoftwareInventory',
        meta: {
          title: '服务'
        },
        component: () => import('@/views/SoftwareInventory')
      },
      {
        path: 'hardware',
        name: 'HardwareInventory',
        meta: {
          title: '硬件'
        },
        component: () => import('@/views/HardwareInventory')
      },
      {
        path: 'service',
        name: 'ServiceInventory',
        meta: {
          title: '信息系统'
        },
        component: () => import('@/views/ServiceInventory')
      },
      {
        path: 'operation-company',
        name: 'OperationCompany',
        meta: {
          title: '运维公司'
        },
        component: () => import('@/views/OperationCompany')
      },
      {
        path: 'public-ip',
        name: 'PublicIPInventory',
        meta: {
          title: '公网 IP'
        },
        component: () => import('@/views/PublicIpInventory')
      },
      {
        path: 'port-map',
        name: 'PortMapInventory',
        meta: {
          title: '端口映射'
        },
        component: () => import('@/views/PortMapInventory')
      }
    ]
  },
  {
    path: 'devops/information-collection',
    name: 'InformationCollection',
    component: () => import('@/views/InformationCollection'),
    meta: {
      title: '信息归集',
      icon: 'info-collection',
      requireApiPermission: ['service.service.update']
    }
  },
  {
    path: 'devops/automation',
    name: 'Automation',
    meta: {
      title: '自动化',
      icon: 'auto_mation',
      requireModule: 'ops'
    },
    component: () => import('@/layouts/BlankLayout'),
    children: [
      {
        path: 'script-task',
        name: 'ScriptExecute',
        meta: {
          title: '脚本执行',
          requireApiPermission: ['ops.script_task.create']
        },
        component: () => import('@/views/script-execute/ScriptExecute')
      },
      {
        path: 'script-task/:id/detail',
        name: 'ScriptExecuteDetail',
        meta: {
          title: '执行详情',
          hidden: true,
          requireApiPermission: ['ops.script_task.view']
        },
        component: () => import('@/views/script-execute/ExecuteDetail')
      },
      {
        path: 'script-task/history',
        name: 'ScriptExecuteHistory',
        meta: {
          title: '执行历史',
          requireApiPermission: ['ops.script_task.view']
        },
        component: () => import('@/views/script-execute/HistoryList')
      }
    ]
  }
]

export default devopsRoutes
